import React from "react";
import VLibras from "@djpfs/react-vlibras";

export function VLibrasComponent() {
  return <VLibras forceOnload />;
}